import { FunctionComponent } from 'react'

import Avatar from './avatar'

const PersonCell: FunctionComponent<{ name: string }> = ({ name }) => (
  <div className="cell-person">
    <Avatar name={name} size="sm" />
    <span>{name}</span>
  </div>
)

export default PersonCell
